<app-cms-layout [title]="eventManagementTitle | t"
                [titleHelpText]="eventManagementTitleDescription | t">
  <ng-container actions>
    <app-cms-actions [itemId]="innerForm.controls.event_id.value"
                     itemType="event"
                     (deleteItem)="deleteEvent()"
                     (saveItem)="saveSection()"></app-cms-actions>
  </ng-container>
  <ng-container mainNavigation>
    <app-cms-entity-management-nav [options]="MODIFY_EVENT_STEPS"
                                   [activeOption]="activeModifyEventStep"
                                   (changeActiveOption)="changeActiveModifyEventStep($event)"></app-cms-entity-management-nav>
  </ng-container>

  <ng-container content>
    <app-event-management-basic-details *ngIf="activeModifyEventStep === MODIFY_EVENT_STEP_ID.BASIC_DETAILS"
                                        [disciplinesForm]="disciplinesForm"
                                        [innerForm]="innerForm"></app-event-management-basic-details>

    <app-event-management-registration-details *ngIf="activeModifyEventStep === MODIFY_EVENT_STEP_ID.REGISTRATION_DETAILS"
                                               [innerForm]="innerForm"></app-event-management-registration-details>
  </ng-container>
</app-cms-layout>
